import Modal from './Modal';
import ConfirmModal from './ConfirmModal';
import UserAvatar from './UserAvatar';
import CustomSelect from './CustomSelect';
import { UserPlusIcon, DeleteIcon } from './Icons';
import useUserManagement, { ROLE_OPTIONS } from '../hooks/useUserManagement';

export default function UserManagementModal({ users, onClose, onUsersChanged, showToast }) {
  const {
    showAddForm, setShowAddForm, email, setEmail, displayName, setDisplayName,
    password, setPassword, role, setRole, saving, deleteTarget, setDeleteTarget,
    handleAddUser, handleRoleChange, handleDeleteUser,
  } = useUserManagement({ onUsersChanged, showToast });

  return (
    <>
      <Modal title="User Management" onClose={onClose}>
        <div className="user-management-list">
          {users.map((u) => (
            <div key={u.uid} className="user-management-item">
              <UserAvatar user={u} size={44} />
              <div className="user-management-item-info">
                <div className="user-management-item-name">{u.displayName}</div>
                <div className="user-management-item-email">{u.email}</div>
              </div>
              <div className="user-management-item-actions">
                <CustomSelect
                  value={u.role}
                  onChange={(val) => handleRoleChange(u.uid, val)}
                  options={ROLE_OPTIONS}
                  size="sm"
                  compact
                />
                <button
                  className="btn-icon"
                  onClick={() => setDeleteTarget(u.uid)}
                  title="Remove user"
                >
                  <DeleteIcon size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {showAddForm ? (
          <form className="add-user-form" onSubmit={(e) => { e.preventDefault(); handleAddUser(); }}>
            <h4><UserPlusIcon size={16} /> Add New User</h4>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Display Name</label>
              <input
                className="form-input"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Full name"
                required
                autoFocus
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Email</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Temporary Password</label>
              <input
                className="form-input"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min 6 characters"
                required
                minLength={6}
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Role</label>
              <CustomSelect value={role} onChange={setRole} options={ROLE_OPTIONS} />
            </div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => setShowAddForm(false)}>Cancel</button>
              <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
                {saving ? 'Creating...' : 'Create User'}
              </button>
            </div>
          </form>
        ) : (
          <button className="btn btn-secondary btn-sm" onClick={() => setShowAddForm(true)}>
            <UserPlusIcon size={14} /> Add User
          </button>
        )}
      </Modal>

      {deleteTarget && (
        <ConfirmModal
          message="Remove this user from the board? They will no longer be able to access the application."
          onConfirm={handleDeleteUser}
          onCancel={() => setDeleteTarget(null)}
          confirmLabel="Remove"
        />
      )}
    </>
  );
}
